import { cva } from "class-variance-authority";
import type { ReactNode } from "react";
import { useDesignSystemI18n } from "../../providers";
import { classNames } from "../../utils";

const formLabelStyles = cva("flex w-full gap-1 font-medium text-neutral text-sm");

type FormLabelProps = {
	children: ReactNode;
	htmlFor: string;
	className?: string;
	isRequired?: boolean;
};

export const IsRequiredStar = () => {
	const { required } = useDesignSystemI18n();

	return (
		<>
			<span className="text-critical" aria-hidden="true">
				*
			</span>
			<span className="sr-only">({required})</span>
		</>
	);
};

export const FormLabel = ({ children, htmlFor, className, isRequired }: FormLabelProps) => {
	return (
		<label htmlFor={htmlFor} className={classNames(formLabelStyles(), className)}>
			{children} {isRequired && <IsRequiredStar />}
		</label>
	);
};
